import styled from '@emotion/styled'

export const CategoriesWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-gap: 10px;
  justify-content: space-between;
`
